import { useState, useEffect } from "react";

import "../../../styles/Auth/customer.css"
import { getData, putData } from "../../../webService/webservice.js"
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { Box, Button } from '@mui/material';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import getStatusStyle from "../../../utils/statusStyle.js";
const ViewCustomerPage = () => {

    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Customer Name',
        'Service Name',
        'Booking Date',
        'Booking Time',
        'Status',
        'Action',
    ];

    const { id } = useParams();
    const navigate = useNavigate();
    const [customer, setCustomer] = useState({});
    const [loading, setLoading] = useState(true);
    const [BookingToDelete, setBookingToDelete] = useState(null);
    const [open, setOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [filteredBookings, setFilteredBookings] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [bookingDate, setBookingDate] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    const [editBookingId, setEditBookingId] = useState(null);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [formData, setFormData] = useState({
        customerId: "",
        serviceId: "",
        appointmentDate: "",
        timeSlot: "",
        status: "",
        remarks: "",
    });
    const handleViewCustomer = async () => {
        try {
            setLoading(true);
            const sessionToken = sessionStorage.getItem("Token");
            const response = await getData(`customers/customer/${id}`, sessionToken);
            setCustomer(response.data?.[0]);
        } catch (error) {
            console.error("Failed to fetch customer", error);
            toast.error("Failed to fetch customer");
        } finally {
            setLoading(false);
        };
    }

    useEffect(() => {
        handleViewCustomer();
    }, [id]);

    useEffect(() => {
        if (customer?.bookingId) {
            setFilteredBookings(customer.bookingId);
        }
    }, [customer]);

    if (loading) return <p>Loading...</p>;
    if (!customer) return <p>Customer not found</p>;
    
    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value); // 👈 allow "all"
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const handleFilter = () => {
        let filtered = [...(customer.bookingId || [])];

        if (statusFilter) {
            filtered = filtered.filter(
                (b) => b.status?.toLowerCase() === statusFilter.toLowerCase()
            );
        }

        if (bookingDate) {
            filtered = filtered.filter(
                (b) =>
                    new Date(b.appointmentDate).toLocaleDateString() ===
                    new Date(bookingDate).toLocaleDateString()
            );
        }

        setFilteredBookings(filtered);
    };

    const handleClear = () => {
        setStatusFilter("");
        setBookingDate("");
        setFilteredBookings(customer?.bookingId || []);
    };

    const handleUpdateBooking = async (e) => {
        e.preventDefault();
        setLoading(true);
        const appointmentDateISO = new Date(formData.appointmentDate).toISOString();
        const timeSlotISO = new Date(
            `${formData.appointmentDate}T${formData.timeSlot}`
        ).toISOString();
        try {
            const token = sessionStorage.getItem("Token");
            const updatedBookingData = {
                storeId: formData.storeId,
                customerId: formData.customerId,
                appointmentDate: appointmentDateISO,
                timeSlot: timeSlotISO,
                status: formData.status
            };

            console.log("Updating Booking with data:", updatedBookingData);

            const response = await putData(`appointmentbookings/appointmentbooking/${editBookingId}`, updatedBookingData, token);

            toast.success(response.message || 'Booking updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                customerId: "",
                appointmentDate: "",
                timeSlot: "",
                status: "",
                remarks: "",
            });
            setIsEditMode(false);
            setIsPopupMode(false)
            triggerRefresh();
            navigate('/customers');
        } catch (error) {
            toast.error("Error updating Booking.");
        }
    };

    return (
        <div className="customer-layout">
            <div className="customer-content">
                <main className="customer-main">
                    <div className="customer-profile-container">
                        <button className="back-button" type="button" onClick={() => navigate('/customers')}>Back</button>

                        <div className="customer-header">
                            <div className="customer-info">
                                <div className="customer-avatar">
                                    <img
                                        src={
                                            customer.customerImageObject?.uri
                                                ? `${process.env.REACT_APP_API_URL}${customer.customerImageObject.uri}`
                                                : "/assets/mdi--user.svg"
                                        }
                                        alt={customer.name}
                                    />
                                </div>
                                <div className="customer-details">
                                    <h2>{customer.name}</h2>
                                    <p><Icon icon="mdi:email-outline" width="14" height="14" style={{ marginRight: "6px" }} /> {customer.email}</p>
                                    <p><Icon icon="mdi:phone-outline" width="14" height="14" style={{ marginRight: "6px" }} /> {customer.phoneNumber || customer.mobileNumber}</p>
                                </div>
                            </div>

                            <div className="customer-actions">

                                <button
                                    type="button" // prevents form submit
                                    className="edit-btn"
                                    onClick={(e) => {
                                        e.stopPropagation(); // stop row clicks if inside table
                                        console.log('Edit clicked for customer id:', customer._id);
                                        navigate(`/customers/customer/${customer._id}/edit`);
                                    }}
                                >
                                    Edit
                                </button>
                            </div>
                        </div>

                        <div className="customer-view-stats">
                            <div className="stat-heading">
                                <h4 className="stat-title">Bookings</h4>
                            </div>
                            <div className="stat">
                                <h3>{customer.bookingCounts.completed}</h3>
                                <p>Completed</p>
                            </div>
                            <div className="stat">
                                <h3>{customer.bookingCounts.inProgress}</h3>
                                <p>In Progress</p>
                            </div>
                            <div className="stat">
                                <h3>{customer.bookingCounts.pending}</h3>
                                <p>Pending</p>
                            </div>
                            <div className="stat">
                                <h3>{customer.bookingCounts.cancelled}</h3>
                                <p>Cancelled</p>
                            </div>
                            <div className="stat">
                                <h3>{customer.bookingCounts.scheduled}</h3>
                                <p>Scheduled</p>
                            </div>
                            <div className="stat">
                                <h3>₹{customer.totalEarnings}</h3>
                                <p>Earnings via customer</p>
                            </div>
                        </div>
                    </div>
                    <div className="search-filter">
                        <div className="filter-container" style={{ margin: "20px 0" }}>
                            <select
                                id="status-filter"
                                className="status-filter"
                                value={statusFilter}
                                onChange={(e) => setStatusFilter(e.target.value)}
                            >
                                <option value="">All Status</option>
                                <option value="Completed">Completed</option>
                                <option value="Pending">Pending</option>
                                <option value="Cancelled">Cancelled</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Rejected">Rejected</option>
                                <option value="Approved">Approved</option>
                                <option value="Scheduled">Scheduled</option>
                            </select>

                            <input
                                type="date"
                                id="date-filter"
                                className="date-filter"
                                value={bookingDate}
                                onChange={(e) => setBookingDate(e.target.value)}
                            />

                            <button className="apply-filter-btn" onClick={handleFilter}>Apply</button>
                            <button className="clear-filter-btn" onClick={handleClear}>Clear</button>
                            <button className="Add-Booking-Button" >Add Booking</button>
                        </div>

                    </div>
                    <TableContainer component={Paper} sx={{
                        borderRadius: '12px',
                        maxHeight: 400,
                        overflowY: "auto",
                        '&::-webkit-scrollbar': { display: 'none' },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}>
                        <Table className="custom-booking-table"
                            sx={{
                                '& td, & th': {
                                    border: 'none',
                                },
                                border: 'none',
                            }}>
                            <TableHead className="custom-booking-head">
                                <TableRow>
                                    {headings.map((heading, index) => (
                                        <TableCell
                                            key={index}
                                            sx={{
                                                border: 'none',
                                                padding: '12px 16px',
                                                textAlign: 'center',
                                                position: "sticky",
                                                top: 0,
                                                backgroundColor: '#F7EAE2',
                                                zIndex: 1,

                                            }}
                                        >
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '4px',
                                                    color: '#000000',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                }}
                                            >
                                                {heading}
                                            </Typography>
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(() => {
                                    const bookingArray = Array.isArray(filteredBookings)
                                        ? filteredBookings
                                        : filteredBookings
                                            ? [filteredBookings]
                                            : [];

                                    return bookingArray.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={5}>
                                                <Typography
                                                    sx={{
                                                        textAlign: 'center',
                                                        padding: '20px',
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    No booking Details Available.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        bookingArray.map((booking, index) => (
                                            <TableRow key={booking._id || index}>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {customer.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {customer.name}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {new Date(booking.appointmentDate).toLocaleDateString()}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {new Date(booking.timeSlot).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                        })}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    {(() => {
                                                        const { label, bg, hover } = getStatusStyle(booking.status);
                                                        return (
                                                            <Button
                                                                variant="contained"
                                                                sx={{
                                                                    backgroundColor: bg,
                                                                    color: "#fff",
                                                                    fontWeight: 600,
                                                                    padding: "4px 8px",
                                                                    borderRadius: "20px",   // pill style
                                                                    width: "130px",
                                                                    textTransform: "none",
                                                                    "&:hover": { backgroundColor: hover },
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    margin: "0 auto",
                                                                }}
                                                            >
                                                                {label}
                                                            </Button>
                                                        );
                                                    })()}
                                                </TableCell>
                                                <TableCell>
                                                    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                        <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }}
                                                            onClick={() => {
                                                                const appointmentDate = booking.appointmentDate
                                                                    ? new Date(booking.appointmentDate).toISOString().split("T")[0] // "2025-08-28"
                                                                    : "";

                                                                const timeSlot = booking.timeSlot
                                                                    ? new Date(booking.timeSlot).toISOString().substring(11, 16) // "16:03"
                                                                    : "";
                                                                setFormData({
                                                                    customerId: booking.customerId || '',
                                                                    serviceId: booking.serviceId || '',
                                                                    storeId: booking.storeId || '',
                                                                    appointmentDate,
                                                                    timeSlot,
                                                                    status: booking.status || '',
                                                                    remarks: booking.remarks || ''
                                                                });

                                                                setEditBookingId(booking._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    );
                                })()}
                            </TableBody>

                        </Table>
                    </TableContainer>
                    <div className="service-bottom">
                        <div className="service-section show-entries">
                            <span className="text-label">Show</span>
                            <select className="entries-select" value={limit}
                                onChange={handleItemsPerPageChange}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="all">All</option>
                            </select>
                            <span className="text-label">Entries</span>
                        </div>
                        <div className="service-section showing-range">
                            {
                                limit === 'all'
                                    ? `Showing all ${totalCount} entries`
                                    : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                            }
                        </div>
                        <div className="service-section spacer"></div>
                        <div className="service-section pagination-buttons">
                            <button
                                className="pagination-btn"
                                disabled={currentPage === 1}
                                onClick={() => handlePageChange("prev")}
                            >Previous</button>
                            <button
                                className="pagination-btn"
                                disabled={currentPage === totalPages}
                                onClick={() => handlePageChange("next")}
                            >Next</button>
                        </div>
                    </div>
                    {
                        isPopupMode && (
                            <div className='popup-overlay'>
                                <div className="popup-wrapper">
                                    <Icon
                                        icon={closeIcon}
                                        className="popup-close-icon-outside"
                                        onClick={() => {
                                            setIsPopupMode(false);
                                            setIsEditMode(false);
                                            setFormData({
                                                customerId: "",
                                                appointmentDate: "",
                                                timeSlot: "",
                                                status: "",
                                                remarks: "",
                                                storeId: "",
                                            });
                                        }}
                                    />
                                    <div className="popup-form">
                                        <h2 className="popup-title">
                                            {isEditMode ? "Edit Booking" : "Add Booking"}
                                        </h2>
                                        <div className='booking-form-container'></div>
                                        {loading && <div className="form-blocker"></div>}
                                        <form className="popup-form-body" onSubmit={handleUpdateBooking}>
                                            <div className="form-group-row">
                                                <div className='form-group'>
                                                    <label htmlFor="appointmentDate" className="input-label">
                                                        Appointment Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="booking-input"
                                                        value={formData.appointmentDate || ""}
                                                        disabled={loading}
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, appointmentDate: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="timeSlot" className="input-label">
                                                        Time Slot
                                                    </label>
                                                    <input
                                                        type="time"
                                                        className="booking-input"
                                                        value={formData.timeSlot || ""}
                                                        disabled={loading}
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, timeSlot: e.target.value })
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label className="input-label">Status</label>
                                                    <select
                                                        id="status"
                                                        className="booking-input"
                                                        required
                                                        value={formData.status}
                                                        disabled={loading}
                                                        onChange={(e) => {
                                                            const selectedStatusType = e.target.value;
                                                            setFormData((prev) => ({ ...prev, status: selectedStatusType }))
                                                        }}
                                                    >
                                                        <option value='' >Select status</option>
                                                        <option value='Scheduled'>Scheduled</option>
                                                        <option value='Completed'>Completed</option>
                                                        <option value='Cancelled'>Cancelled</option>
                                                        <option value='Pending'>Pending</option>
                                                        <option value='In Progress'>In Progress</option>
                                                        <option value='Rejected'>Rejected</option>
                                                        <option value='Approved'>Approved</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-actions">
                                                <button type="submit" className="btn-primary" disabled={loading}>
                                                    {loading ?
                                                        (
                                                            <div className='loader'></div>
                                                        ) : (
                                                            isEditMode ? "Update Booking" : "Add Booking"
                                                        )
                                                    }

                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn-secondary"
                                                    onClick={() => setIsPopupMode(false)}
                                                    disabled={loading}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                </main>
            </div>
        </div>
    );
};

export default ViewCustomerPage;